import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Modal from 'react-bootstrap/Modal';
import "./index.scss";

import ProfileAvatar from "../../../../../components/ui/ProfileAvatar";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import PaginationArrow from "../../../../../components/ui/PaginationArrow";
import Button from "../../../../../components/ui/Button";
import RadioButton from "../../../../../components/ui/RadioButton";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import TechnologyInformation from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/Technologies/TechnologyInformation";
import EndPoints from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/Technologies/EndPoints";

import { filterIcon, searchIcon } from "../../../../../utils/icons";
import { getTechnologiesImageUrl, formatNumber } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getTechnologyList, getScanInfoStats, resetScanInfoStats, resetTechnologiesList } from "../../../../../store/actions/scanInfoAction";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const Technologies = () => {

    const technologyListResponse = useSelector((state) => state.scanInfo?.technologyList);
    const technologyStatsResponse = useSelector((state) => state.scanInfo?.scanInfoStats);

    const filterWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
        triggerListFetch,
        setTriggerListFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    const [activeTab, setActiveTab] = useState("technologyInformation");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTechnology, setSelectedTechnology] = useState("");
    const [scanNotFound, setScanNotFound] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [technologyStats, setTechnologyStats] = useState("");
    const [showViewAllModal, setShowViewAllModal] = useState(false);
    const [technologiesList, setTechnologiesList] = useState(null);
    const [statsLoading, setStatsLoading] = useState(false);

    const [technologySearch, setTechnoogySearch] = useState("");
    const [updatedTechnologySearchValue, setUpdatedTechnologySearchValue] = useState("");

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setContextCurrentPage(newPage)
        setTriggerListFetch(true);
    };

    const getProfileImage = (data, type) => {
        if(type === "profile") {
            const cleanName = data.name.replace(/\//g, '');
            return getTechnologiesImageUrl({ ...data, name: cleanName });
        } else {
            const obj  = {
                name : data.replace(/\//g, '')
            }
            return getTechnologiesImageUrl(obj);
        }
        
    }

    const applyFilter = () => {
        setCurrentPage(1);        
        setShowFilter(false);
        let obj = {
            findings: newFindingsType
        }
        setSelectedFilterValue(obj)
        setContextCurrentPage(1)
        setTriggerListFetch(true);
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1); 
        setSelectedFilterValue({})
        setNewFindingsType("");
        setContextCurrentPage(1)
        setTriggerListFetch(true);
    }

    const fetchTechnologyStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.technology.technologyStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getScanInfoStats(url));
    },[dispatch, domainId, scanId, organizationId])

    const requestSearch = useMemo(() => debounce((searchTerm) => {        
        setUpdatedTechnologySearchValue(searchTerm)
    }, 500), []);

    const fetchTechnologyList = useCallback(()=>{
        const baseUrl = `&page=${currentPage}&page_size=10`;
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = updatedTechnologySearchValue ? `&query=${updatedTechnologySearchValue}` : ""
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}`
        setIsLoading(true);
        setScanNotFound(false);
        dispatch(getTechnologyList(url))
    },[dispatch, domainId, scanId, organizationId, currentPage, updatedTechnologySearchValue, selectedFilterValue])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchTechnologyStats();
            setCurrentPage(1)
            setContextCurrentPage(1)
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setContextCurrentPage, setTriggerStatsFetch, fetchTechnologyStats]);

    useEffect(() => {
        if (triggerListFetch) {
            fetchTechnologyList();
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, fetchTechnologyList]);

    useEffect(() => {
        setCurrentPage(1); // reset to first page
        setContextCurrentPage(1);
        setTriggerListFetch(true); // trigger fetch
    }, [setTriggerListFetch, setContextCurrentPage, updatedTechnologySearchValue]);

    useEffect(()=>{
        if(technologyListResponse !== null) {
            setTechnologiesList(technologyListResponse)
            if(technologyListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            if(technologyListResponse?.results?.length > 0) {                
                setSelectedTechnology(technologyListResponse?.results[0])
            }
            dispatch(resetTechnologiesList())
            setIsLoading(false);
        }
    },[technologyListResponse, dispatch])

    useEffect(()=>{
        if(technologyStatsResponse !== null) {
            setStatsLoading(false)
            setTechnologyStats(technologyStatsResponse)            
            dispatch(resetScanInfoStats())
        }
    },[technologyStatsResponse, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }        
        }
    },[showFilter])


    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>
                        <Col lg={4}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"technologies"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Technologies</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(technologyStats?.record_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Records</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(technologyStats?.record_type?.new_record)}</span> New</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(technologyStats?.record_type?.existing_record)}</span> Existing</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={4}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"technologies"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="sub-domain-type-container web-server-type-container rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Technology Name</p>
                                            {technologyStats !== "" && technologyStats?.technology_type?.records && Object.entries(technologyStats?.technology_type?.records).length > 4 && <p className="view-all" onClick={()=>{setShowViewAllModal(true)}}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(technologyStats?.technology_type?.total)} <span>Total Records</span></p>
                                        </div>
                                        <div className="sub-domain-content mt-3">
                                            <Row className="px-3">
                                                {
                                                    technologyStats !== "" && technologyStats?.technology_type?.records && Object.entries(technologyStats?.technology_type?.records).length > 0 &&
                                                    Object.entries(technologyStats?.technology_type?.records).map(([key, value], index) => {
                                                        if(index <= 5) {
                                                            return (
                                                                <>
                                                                    <Col lg={2} className="mb-3 p-0" key={index}>
                                                                        <div className="d-flex align-items-center">
                                                                            <p className="count-type technology-count">{key}</p>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3" key={value}>
                                                                        <div className="technology-text-right w-100">
                                                                            <p className="count-value">{formatNumber(value)}</p>
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            )
                                                        }
                                                        return null;                                            
                                                    })
                                                }
                                            </Row>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>                        
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={3}>
                            <div className="bg-white-with-shadow subdomain-list-container h-100">
                                <div className="list-heading px-3 pt-3 d-flex justify-content-between align-items-center">
                                    <h1>Technology List</h1>
                                    {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                    <div className="position-relative">
                                        <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                            <h6>New Findings</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    newFindingsOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className="filter-apply-btn mt-3">
                                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === ""} buttonClicked={()=>{applyFilter()}}/>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                                <div className="search-container px-3 position-relative">
                                    <span className="position-absolute search-icon">{searchIcon()}</span>
                                    <input type="text" 
                                        placeholder="Search" 
                                        className="w-100 rounded input" 
                                        value={technologySearch} 
                                        onChange={(e)=>{                                            
                                            setTechnoogySearch(e.target.value)
                                            requestSearch(e.target.value)
                                            setCurrentPage(1);
                                            setContextCurrentPage(1);
                                            setTriggerStatsFetch(false);
                                        }}
                                    />
                                </div>
                                <div className="list-main-container technology-list">
                                    { !isLoading && scanNotFound &&
                                        <NoDataFound noDataText={technologiesList?.description}/>
                                    }
                                    {
                                        isLoading && !scanNotFound ?
                                            <SkeletonLoader type={"line"} count={5} currentPage={"technologies"} />
                                        :
                                        (
                                            technologiesList !== null && technologiesList?.results?.length > 0 &&
                                            technologiesList.results.map((data, index) => {
                                                return (
                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <div className={`sub-domain-list py-2 px-3 ${!data?.new_record ? "full-width" : ""} ${selectedTechnology?.id === data.id ? "active" : ""}`} key={index} onClick={()=>{setSelectedTechnology(data)}}>
                                                            <ProfileAvatar type="profile" firstName={data?.name} secondaryText={data.domain} imageUrl={getProfileImage(data, "profile")} tags={data?.new_record} tagContent={"new"} tagColor={"blue"} />
                                                        </div>
                                                    </motion.div>
                                                )
                                            })
                                        )
                                    }
                                    { !isLoading && technologiesList?.results?.length > 0 &&
                                        <PaginationArrow 
                                            totalCount={technologiesList?.meta?.total_results}
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                        />                                  
                                    }
                                    { !isLoading && technologiesList?.results?.length === 0 &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={"No Data Found"}/>
                                        </motion.div>                                        
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={9}>
                            <div className="bg-white-with-shadow sub-domain-main-container p-3 h-100">
                                <div className="tab-container d-flex rounded">
                                    <p className={`rounded text-center ${activeTab === "technologyInformation" ? "active" : ""}`} onClick={()=>{setActiveTab('technologyInformation')}}>Technology Information</p>
                                    <p className={`rounded text-center ${activeTab === "endPoints" ? "active" : ""}`} onClick={()=>{setActiveTab('endPoints')}}>Endpoints</p>
                                </div>
                                <div className="tab-details-content">
                                    {
                                        !isLoading && scanNotFound ?
                                        <NoDataFound noDataText={technologiesList?.description}/>
                                        :
                                        ( !isLoading && technologiesList?.results?.length === 0 ?
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4 }}
                                            >
                                                <NoDataFound noDataText={"No Data Found"}/>
                                            </motion.div>                                            
                                            :
                                            <>
                                                {activeTab === "technologyInformation" && <TechnologyInformation selectedTechnology={selectedTechnology} isLoading={isLoading} />}
                                                {activeTab === "endPoints" && <EndPoints selectedTechnology={selectedTechnology} domainId={domainId} scanId={scanId} currentPageType="technology"/>}
                                            </>
                                        )
                                    }                                    
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Modal
                        show={showViewAllModal}
                        onHide={()=>setShowViewAllModal(false)}
                        size="md"
                        centered
                        className=""
                        >
                            <Modal.Body>
                                <div className="delete-organization-container">
                                    <h4>Technologies</h4>
                                    <div className="p-2 m-2 type-list-container">
                                        <div className="mt-3">
                                            {
                                                technologyStats !== "" && technologyStats?.technology_type?.records && Object.entries(technologyStats?.technology_type?.records).length > 0 &&
                                                Object.entries(technologyStats?.technology_type?.records).map(([key, value], index) => {
                                                    return (
                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                                        >
                                                            <div key={index}>
                                                                <div className="d-flex align-items-center justify-content-between gap-3 p-2 border-bottom scan-info-type-modal">                                                                
                                                                    <ProfileAvatar type="domain" name={key} imageUrl={getProfileImage(key, "type")} />
                                                                    <p className="count-type total-count">{formatNumber(value)}</p>
                                                                </div>
                                                            </div>
                                                        </motion.div>
                                                    )                                           
                                                })
                                            }
                                        </div> 
                                    </div>
                                    <div className="d-flex justify-content-center gap-3 mt-4">
                                        <div className="w-50">
                                            <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowViewAllModal(false)}/>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                    </Modal>
                </div>
            </div>
        </>
        
    )
}


export default Technologies;